import Head from '@/components/Head';
import CreateConfigurationForm from '@/features/configurations/CreateConfigurationForm';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function CreateConfiguration() {
  const { vehicleId } = useParams();

  return (
    <>
      <Head title="Create configuration" />
      <Box>
        <CreateConfigurationForm
          vehicleId={vehicleId || ''}
        />
      </Box>
    </>
  );
}
